export const LANGUAGE_COOKIE_NAME = 'cedrum_lang';
export const LANGUAGE_STORAGE_KEY = 'cedrum_lang';
export const PSEUDO_LANGUAGE_CODE = 'en-XA';

export const PRODUCTION_LANGUAGE_CODES = Object.freeze(['en', 'de', 'es', 'fr']);

export const LANGUAGE_METADATA = Object.freeze({
  en: Object.freeze({
    code: 'en',
    shortCode: 'EN',
    nativeName: 'English',
    flag: '🇬🇧',
    weekStartsOn: 1,
  }),
  de: Object.freeze({
    code: 'de',
    shortCode: 'DE',
    nativeName: 'Deutsch',
    flag: '🇩🇪',
    weekStartsOn: 1,
  }),
  es: Object.freeze({
    code: 'es',
    shortCode: 'ES',
    nativeName: 'Español',
    flag: '🇪🇸',
    weekStartsOn: 1,
  }),
  fr: Object.freeze({
    code: 'fr',
    shortCode: 'FR',
    nativeName: 'Français',
    flag: '🇫🇷',
    weekStartsOn: 1,
  }),
  [PSEUDO_LANGUAGE_CODE]: Object.freeze({
    code: PSEUDO_LANGUAGE_CODE,
    shortCode: 'XA',
    nativeName: 'Pseudo',
    flag: '🏳️',
    weekStartsOn: 1,
    isPseudo: true,
  }),
});

function isPseudoCode(value) {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace('_', '-');
  return normalized === 'en-xa';
}

export function getSupportedLanguageCodes({ includePseudo = false } = {}) {
  if (!includePseudo) {
    return [...PRODUCTION_LANGUAGE_CODES];
  }

  return [...PRODUCTION_LANGUAGE_CODES, PSEUDO_LANGUAGE_CODE];
}

export function getSwitcherLanguageCodes() {
  return [...PRODUCTION_LANGUAGE_CODES];
}

export function normalizeLanguageCode(input, { includePseudo = false } = {}) {
  if (includePseudo && isPseudoCode(input)) {
    return PSEUDO_LANGUAGE_CODE;
  }

  const raw = String(input || '')
    .trim()
    .toLowerCase();

  if (!raw) {
    return 'en';
  }

  const base = raw.split(/[-_]/)[0];
  if (PRODUCTION_LANGUAGE_CODES.includes(base)) {
    return base;
  }

  return 'en';
}

export function resolveLanguageForFormatting(input) {
  const normalized = normalizeLanguageCode(input, { includePseudo: true });
  if (normalized === PSEUDO_LANGUAGE_CODE) {
    return 'en';
  }
  return normalized;
}

export function getWeekStartsOn(input) {
  const normalized = normalizeLanguageCode(input, { includePseudo: true });
  const meta = LANGUAGE_METADATA[normalized] || LANGUAGE_METADATA.en;
  return Number.isFinite(meta.weekStartsOn) ? meta.weekStartsOn : 1;
}

